import { render, staticRenderFns } from "./pd-pace-features.vue?vue&type=template&id=cd3759be&"
import script from "./pd-pace-features.vue?vue&type=script&lang=js&"
export * from "./pd-pace-features.vue?vue&type=script&lang=js&"
import style0 from "./pd-pace-features.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgImg: require('/opt/build/repo/storefront/components/legacy/global/sg-img.vue').default,Slider: require('/opt/build/repo/storefront/components/legacy/global/slider.vue').default})
